// extracted by mini-css-extract-plugin
export var row = "parking-availability-row-module--row--4j4fj";
export var availabilityItem = "parking-availability-row-module--availabilityItem--19lmK";
export var invalidStatusItem = "parking-availability-row-module--invalidStatusItem--1Mfgx";
export var emptyStatusItem = "parking-availability-row-module--emptyStatusItem--2LN05";
export var crowdedStatusItem = "parking-availability-row-module--crowdedStatusItem--dlCeh";
export var fullStatusItem = "parking-availability-row-module--fullStatusItem--21soh";
export var statusItemText = "parking-availability-row-module--statusItemText--1621L";
export var availabilityText = "parking-availability-row-module--availabilityText--NeDD3";
export var info = "parking-availability-row-module--info--147vY";